(function() {
    const WebFont = require('webfontloader');

    WebFont.load({
        google: {
            families: ['Montserrat:300,400,700:latin-ext']
        }
    });
    
    
})();
